import React from "react";
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import classnames from "classnames";
import {
	getMaxGamesPerSet,
	getMaxTieBreakPoints,
	isSetTiebreakEligible,
	getAdditionalGames
} from "@prestosports/prestostats-core/Tennis";
import gameSetStyles from "../styles/GameSet.style";
import NumberFormat from "../../../util/number-format";
import { useEventContext } from "../../../state/events/context";
import SetAndTiebreak from "./SetAndTiebreak";
import { useGameContextContext } from "../../../state/game-context/context";

const GameSet = ({
	disabled,
	index,
	match,
	isSelected,
	onClick = () => {},
	onAwayScoreChange = () => {},
	onAwayTiebreakChange = () => {},
	onHomeScoreChange = () => {},
	onHomeTiebreakChange = () => {},
	set,
	maxSetTiebreak
}) => {
	const classes = gameSetStyles();
	const { state: eventState } = useEventContext();

	const { state: gameContextState } = useGameContextContext();
	const ruleSetId = gameContextState.ruleSetId();

	const currentEventSettings = eventState.currentEventSettings();
	const { gameConfiguration } = currentEventSettings;

	const maxGamesPerSetValue =
		getMaxGamesPerSet(match, gameConfiguration) + getAdditionalGames(ruleSetId);
	const maxTieBreakValue =
		maxSetTiebreak || getMaxTieBreakPoints(match, gameConfiguration);

	const { away, home } = set;
	const tiebreakDisabled =
		disabled || !isSetTiebreakEligible(set, match, gameConfiguration);

	return (
		<Box
			display="flex"
			alignItems="center"
			className={classnames(classes.set, {
				[classes.selectedSet]: isSelected
			})}
			onClick={() => onClick()}
		>
			<Typography
				className={classnames(classes.title, { [classes.textDisabled]: disabled })}
			>
				{NumberFormat.withOrdinal(index + 1).toUpperCase()}
			</Typography>
			<SetAndTiebreak
				disabled={disabled}
				tiebreakDisabled={tiebreakDisabled}
				teamSide="away"
				score={away.score}
				maxScore={maxGamesPerSetValue}
				tiebreak={away.tiebreak}
				maxTiebreak={maxTieBreakValue}
				onFocus={() => onClick()}
				onChange={(score) => {
					onAwayScoreChange({ score, tiebreak: away.tiebreak });
				}}
				onTiebreakChange={(value) => {
					onAwayTiebreakChange({ score: away.score, tiebreak: value });
				}}
			/>
			<div className={classes.spacing} />
			<SetAndTiebreak
				disabled={disabled}
				tiebreakDisabled={tiebreakDisabled}
				teamSide="home"
				score={home.score}
				maxScore={maxGamesPerSetValue}
				tiebreak={home.tiebreak}
				maxTiebreak={maxTieBreakValue}
				onFocus={() => onClick()}
				onChange={(score) => {
					onHomeScoreChange({ score, tiebreak: home.tiebreak });
				}}
				onTiebreakChange={(value) => {
					onHomeTiebreakChange({ score: home.score, tiebreak: value });
				}}
			/>
		</Box>
	);
};

export default GameSet;
